import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { checkToken } from '../filters'
import QrCode from '@/components/QrCode.vue'
import PenaltyReport from '../components/views/reports/penaltyReport.vue'
import nceLevyReport from '../components/views/reports/nceLevyReport.vue'
import growerSalesReport from '../components/views/reports/growerSalesReport.vue'
import retryPayments from '@/components/views/farmers/retryPayments.vue'
const DashView = () =>
	import(/* webpackChunkName: "dash" */ '../components/Dash.vue')
const ConfirmView = () =>
	import(/* webpackChunkName: "home" */ '../components/confirmpage.vue')
const ViewHoldingWarrant = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/holdingwarrant.vue'
	)
const ViewHoldingWarrants = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/viewholdingwarrant.vue'
	)
const InitiateWarrantCollection = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/initiatecollection.vue'
	)

const ApproveWarrantCollection = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/as.vue'
	)

const WarrantPendingCollection = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/pendingcollection.vue'
	)
const MarkWarrantCollected = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/warrant/markwarrantcollected.vue'
	)
const PasswordResetView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/preset/passwordreset.vue'
	)
const OTPView = () =>
	import(/* webpackChunkName: "home" */ '../components/preset/otp.vue')
const OTPConfrimView = () =>
	import(/* webpackChunkName: "home" */ '../components/otpconfirmpage.vue')

// Import Views - Dash
const DashboardView = () =>
	import(/* webpackChunkName: "dash" */ '../components/views/Dashboard.vue')
const CreateInternalUserView = () =>
	import(
		/* webpackChunkName: "users" */ '../components/views/user/createinternaluser.vue'
	)
const ApproveInternalUserView = () =>
	import(
		/* webpackChunkName: "users" */ '../components/views/user/approveinternalusers.vue'
	)
const ViewInternalUserView = () =>
	import(
		/* webpackChunkName: "users" */ '../components/views/user/viewinternalusers.vue'
	)

const CreatePermissionView = () => import(/* webpackChunkName: "settings" */ '../components/views/permission/createpermission.vue')
const ViewPermissionView = () => import(/* webpackChunkName: "settings" */ '../components/views/permission/viewpermissions.vue')
const CreateRoleView = () => import(/* webpackChunkName: "settings" */ '../components/views/role/createrole.vue')
const ViewRoleView = () => import(/* webpackChunkName: "settings" */ '../components/views/role/viewrole.vue')
const UpdatePasswordView = () => import(/* webpackChunkName: "dash" */ '../components/views/user/updatepassword.vue')
const PasswordResetRequest = () => import(/* webpackChunkName: "settings" */ '../components/preset/passwordresetrequest.vue')
const CreateOrganizationView = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/createorganization.vue')
const ViewOrganizationView = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/vieworganization.vue')
const ApproveOrganizationView = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/approveorganization.vue')
const OrganizationUsers = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/organizationusers.vue')
const ApproveOrganizationUsers = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/approveorganizationusers.vue')
const CatalogueUpload = () => import(/* webpackChunkName: "catalogueFile" */ '../components/views/file/catalogue/catalogueupload.vue')
const CatalogueDetails = () => import(/* webpackChunkName: "catalogueDetails" */ '../components/views/catalogue/catalogue_details.vue')
const EstateCuredDetails = () => import(/* webpackChunkName: "estateCuredDetails" */ '../components/views/file/estatecureddetail.vue')
const EstateCuredDetailsFile = () => import(/* webpackChunkName: "estateCuredDetailsFile" */ '../components/views/file/estatecureddetailfile.vue')
const EstateCuredParchmentDetails = () => import(/* webpackChunkName: "estateCuredParchmentDetails" */ '../components/views/file/estatecuredparchmentdetail.vue')
const EstateCuredCleanDetails = () => import(/* webpackChunkName: "estateCuredCleanDetails" */ '../components/views/file/estatecuredcleandetail.vue')
// const EstateCuredDetails = () => import(/* webpackChunkName: "catalogue" */ '../components/views/file/estatecured_details.vue')
const SweepingsDetails = () => import(/* webpackChunkName: "sweepingDetails" */ '../components/views/file/sweepingfiledetails.vue')

const SweepingsHoldingWarrants = () =>
	import(
		/* webpackChunkName: "SweepingsWarrants" */ '../components/views/warrant/viewsweepingholdingwarrant.vue'
	)
const SweepingsConfirmWarrants = () => import(/* webpackChunkName: "SweepingsConfirmWarrants" */ '../components/views/file/sweepingsconfirmwarrant.vue')
const CatalogueDeletedDetails = () => import(/* webpackChunkName: "catalogueDeleteDetails" */ '../components/views/file/catalogue/deletedcatalogue_details.vue')
const ParchmentUpload = () => import(/* webpackChunkName: "parchmentUpload" */ '../components/views/file/parchmentupload.vue')
const ParchmentDetails = () => import(/* webpackChunkName: "parchmentDetails" */ '../components/views/file/parchmentdetails.vue')
const ParchmentDeletedDetails = () => import(/* webpackChunkName: "parchmentDeleteDetails" */ '../components/views/file/deletedparchmentdetails.vue')
const CleanCoffeeUpload = () => import(/* webpackChunkName: "cleancoffee" */ '../components/views/file/cleancoffeeupload.vue')
const EstateCuredUpload = () => import(/* webpackChunkName: "estatecured" */ '../components/views/file/estatecuredupload.vue')
const EstateCuredMillerUpload = () => import(/* webpackChunkName: "estatecuredmiller" */ '../components/views/file/estatecuredmiller.vue')
const EstatecuredMillerDetails = () => import(/* webpackChunkName: "estatecureddetails" */ '../components/views/file/estatecuredmillerdetails.vue')
const SweepingsUpload = () => import(/* webpackChunkName: "sweepingsupload" */ '../components/views/file/sweepingsupload.vue')
const SweepingsCharges = () => import(/* webpackChunkName: "sweepingscharges" */ '../components/views/file/sweepingscharges.vue')
const SweepingsCatalogue = () => import(/* webpackChunkName: "sweepingscatalogue" */ '../components/views/file/sweepingscatalogue.vue')

const CleancoffeeDetails = () => import(/* webpackChunkName: "cleancoffeedetails" */ '../components/views/file/cleancoffeedetails.vue')
const CleancoffeeDeletedDetails = () => import(/* webpackChunkName: "cleancoffeedeleted" */ '../components/views/file/deletedcleancoffeedetails.vue')
const AuctionUpload = () => import(/* webpackChunkName: "auction" */ '../components/views/file/auctionupload.vue')
const BuyerInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/buyerinvoices.vue')
const ViewInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/viewinvoice.vue')
const ViewConfirmedInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/confirmedinvoices.vue')
const ViewUnconfirmedInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/generatedinvoices.vue')
const AuctionResults = () => import(/* webpackChunkName: "auction" */ '../components/views/auction/auctionresults.vue')
const AuctionResultsInFile = () => import(/* webpackChunkName: "auction" */ '../components/views/auction/auctionresultsinfile.vue')
const DeletedAuctionResultsInFile = () => import(/* webpackChunkName: "auction" */ '../components/views/auction/deletedauctionresultsinfile.vue')
const Charge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/charge.vue')
const BrockerCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/brockercharge.vue')
const WarehouseCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/warehousecharge.vue')
const MillingCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/milling.vue')
const MillingChargeView = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/milling_view.vue')
const MillingChargeApprove = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/milling_approve.vue')

const SocietyCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/society.vue')
const SocietyChargeView = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/society_view.vue')
const SocietyChargeApprove = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/society_approve.vue')

const BrokerCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/broker.vue')
const BrokerChargeApprove = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/broker_approve.vue')
const BrokerChargeView = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/broker_view.vue')
const WarehouseNewCharge = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/warehouse.vue')
const WarehouseChargeApprove = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/warehouse_approve.vue')
const WarehouseChargeView = () => import(/* webpackChunkName: "charges" */ '../components/views/charge/warehouse_view.vue')
const BuyerEslips = () => import(/* webpackChunkName: "eslip" */ '../components/views/eslips/buyereslips.vue')
const ConfirmWarrant = () => import(/* webpackChunkName: "warrant" */ '../components/views/warrant/confirmwarrant.vue')
const ViewWarrant = () => import(/* webpackChunkName: "warrant" */ '../components/views/warrant/viewwarrant.vue')
const WarrantUtilization = () => import(/* webpackChunkName: "warrant" */ '../components/views/warrant/ewarrantutilization.vue')
const ViewReceivedPayments = () => import(/* webpackChunkName: "payments" */ '../components/views/payment/receivedpayments.vue')
const ViewSettlements = () => import(/* webpackChunkName: "settlement" */ '../components/views/payment/approvesettlements.vue')
const ViewPaymentExceptions = () => import(/* webpackChunkName: "settlement" */ '../components/views/payment/paymentexceptions.vue')
const EUDRGeomapAgent = () => import(/* webpackChunkName: "eudrGeomap" */ '../components/views/eudr/geomapagent.vue')
const EUDRFarmersReport = () => import(/* webpackChunkName: "eudrGeomap" */ '../components/views/eudr/report.vue')
const EUDRDueDeligenceStatement = () => import(/* webpackChunkName: "eudrDueDiligence" */ '../components/views/eudr/duediligencestatement.vue')
const EUDRGeneratedDDS = () => import(/* webpackChunkName: "eudrDueDiligence" */ '../components/views/eudr/generatedds.vue')
const EUDRConfirmDDS = () => import(/* webpackChunkName: "eudrDueDiligence" */ '../components/views/eudr/confirmdds.vue')


const ViewTransactions = () =>
	import(
		/* webpackChunkName: "payments" */ '../components/views/transaction/settlement.vue'
	)
const UploadFarmers = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/uploadfarmers.vue'
	)
const UploadFarmerCompany = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/uploadfarmercompany.vue'
	)
const ViewFarmers = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/viewfarmers.vue'
	)

const PaymentGenerationSchedule = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/PaymentGenerationSchedule.vue'
	)

const RetryFarmerPayments = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/retryPayments.vue'
	)

const ApproveFarmerPaymentRetries = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/ApprovePaymentRetries.vue'
	)
const ApprovePaymentSchedule = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/ApprovePaymentSchedule.vue'
	)

const CommunalRatesView = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/CommunalRatesView.vue'
	)

const FarmerStatementView = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/FarmerStatement.vue'
	)

const ViewFarmerSchedule = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/viewFarmerSchedule.vue'
	)

const ViewCherryReport = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/viewCherryReport.vue'
	)
const CcarfUsdKesRate = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/ccarf/ccarfUsdKesRate.vue'
	)
const SetCommunalRateLimit = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/setCommunalRateLimit.vue'
	)
const FarmerUpdateApprove = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/approvefarmerupdate.vue'
	)

const ViewLoanRequests = () => import(/* webpackChunkName: "farmers" */ '../components/views/loan/viewloanrequests.vue')
const ViewApprovedLoanRequests = () => import(/* webpackChunkName: "farmers" */ '../components/views/loan/approvedloanrequests.vue')
const FarmersDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/farmers_details.vue')
const FarmerCompanyDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/farmercompany_details.vue')
const LimitDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/limit_details.vue')
const UploadLimits = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/uploadlimits.vue')
const FarmersSummary = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/farmersummary.vue')
const FarmersSummaryDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/farmersummary_details.vue')
const FarmerLoanHistory = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/farmerloans.vue')
const LoanSummaryDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/loan/loansummary_details.vue')
const LoanRequests = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/viewLoanRequests.vue')
const GrowerStock = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growerstockerdetails.vue')
const GrowerStock2 = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growerstockdetails2.vue')
const NonCheckOff = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growernoncheckoffaccount.vue')
const NonCheckOff2 = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growernoncheckoffaccount2.vue')
const GrowerSaleStatement = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growersalesstatement2.vue')
const GrowerStockStatusDet = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growerstockstatusdetail.vue')
const GrowerStockStatusDet2 = () => import(/* webpackChunkName: "farmers" */ '../components/views/grower/growerstockstatusdetail2.vue')

const ViewLimits = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/viewlimits.vue'
	)
const LoanSummary = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/loan/loansummary.vue'
	)
const LoginView = () =>
	import(/* webpackChunkName: "home" */ '../components/Login.vue')
const ContactusView = () =>
	import(/* webpackChunkName: "home" */ '../components/contactus.vue')
const HomeView = () =>
	import(/* webpackChunkName: "home" */ '../components/home.vue')
const LoginTokenValidateView = () =>
	import(/* webpackChunkName: "home" */ '../components/LoginOtp.vue')
const TokenValidateView = () =>
	import(/* webpackChunkName: "home" */ '../components/tokenvalidate.vue')
const PaidAndPendingPaymentsRpts = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/paid_pending.vue'
	)
const GrowersSettlementDetailsRpts = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/grower_settlement_details.vue'
	)
const GrowersSettlementRpts = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/growers_settlement.vue'
	)
const UnbulkingTracingRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/UnbulkingTracingRpt.vue'
	)
const BuyersRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/buyer_report.vue'
	)
const WarehouseRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/warehouse_report.vue'
	)
const SaleDates = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/sla/sale_dates_view.vue'
	)
const DefaultSLA = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/sla/default_sla_view.vue'
	)

const TaxType = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/taxtype/tax_type.vue'
	)
const CustomOrgSLA = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/sla/custom_org_sla_view.vue'
	)
const SLASeasons = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/sla/seasons.vue'
	)
const MillersRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/miller_report.vue'
	)
const BrokersRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/broker_report.vue'
	)
const ExceptionalRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/exceptional_report.vue'
	)
const SweepingsRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/sweepings_report.vue'
	)
const GrowerSettlementRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/grower_settlement_report.vue'
	)
const AccountRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/account_report.vue'
	)
const PaymentRpt = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/reports/payment_report.vue'
	)
const CreateCCARFRate = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/ccarf_rate/create_ccarf_rate.vue'
	)
const ViewCCARFRates = () =>
	import(
		/* webpackChunkName: "invoice" */ '../components/views/ccarf_rate/view_ccarf_rates.vue'
	)
const NotFoundView = () =>
	import(/* webpackChunkName: "home" */ '../components/404.vue')
const GrowerSettlementView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/growersettlement.vue'
	)
const GrowerChargeSettlementView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/growerchargesettlement.vue'
	)
const BrokerSettlementView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/brokersettlement.vue'
	)
const NceSettlementView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/ncesettlement.vue'
	)
const PaidEslipsView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/paideslips.vue'
	)
const PendingApprovalEslipsView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/pendingapproval.vue'
	)
const BrokerTransactionsView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/approvebrokertransactions.vue'
	)

const SettleGrowersChargesView = () =>
	import(
		/* webpackChunkName: "home" */ '../components/views/charge-settlement/settlegrowers.vue'
	)
const UploadCherry = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/uploadCherry.vue'
	)
const CreateCherry = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/cherrycreation.vue'
	)
const CreateFarmer = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/farmercreation.vue'
	)
const UploadParchment = () =>
	import(
		/* webpackChunkName: "farmers" */ '../components/views/farmers/uploadParchment.vue'
	)
const fcsLoans = () => import('../components/views/ccarf/ccarfApplication.vue')

const EstateCuredBrokerUpload = () => import(/* webpackChunkName: "estateCuredbrokerUpload" */ '../components/views/file/estatecuredbrokerupload.vue')

// const ViewCherryReport = () =>
//   import(
//      /* webpackChunkName: "farmers" */ '../components/views/farmers/viewCherryReport.vue'
//   )
const ApproveAllOrganizationView = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/approveallorganizations.vue')

const MakersView = () => import(/* webpackChunkName: "organisation" */ '../components/views/organization/makersview.vue')

const SweepingsConfirmedWarrants = () =>
	import(
		/* webpackChunkName: "sweepingswarrants" */ '../components/views/warrant/viewsweepingswarrant.vue'
	)
const SpecialityCatalogueUpload = () => import(/* webpackChunkName: "specialitycatalogue" */ '../components/views/file/specialitycatalogueupload.vue')
const SpecialityCatalogueDetails = () => import(/* webpackChunkName: "specilaitycataloguedetails" */ '../components/views/file/specialitycataloguefiledetails.vue')

const UploadFcsLoanScedule = () =>
	import(
		/* webpackChunkName: "farmerLoanSchedule" */ '../components/views/farmers/uploadfcsloanschedule.vue'
	)
	const LoanScheduleDetails = () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/loan_schedule_details.vue')
const BrokerPayoutSchedule = () => import(/* webpackChunkName: "brokerPayout" */ '../components/views/payment/brokerpayoutschedule.vue')

	const ViewBrokerSchedule = () =>
	import(
		/* webpackChunkName: "viewbrokerPayout" */ '../components/views/payment/viewBrokerPayoutSchedule.vue'
	)
	const ViewBrokerPayoutRequests = () => import(/* webpackChunkName: "viewAllBrokerPayout" */ '../components/views/payment/viewallbrokerpayout.vue')

const BrokerScheduleDetails = () => import(/* webpackChunkName: "scheduleDetails" */ '../components/views/payment/viewuploadedscheduledetails.vue')


const millerInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/MillerBrokerInvoice.vue')
const warehouseInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/WareHouseBrokerInvoice.vue')
const growerInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/GrowerBrokerInvoice.vue')
// const nceInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/NceBrokerInvoice.vue')
const brokerInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/BrokerInvoice')
const nceInvoices = () => import(/* webpackChunkName: "invoice" */ '../components/views/invoice/NceBrokerInvoice.vue')


Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		component: LoginView
	},
	{
		path: '/contactus',
		component: ContactusView
	},
	{
		path: '/',
		component: HomeView
	},
	{
		path: '/:id/otp-validate',
		component: TokenValidateView
	},
	{
		path: '/:id/login/otp-validate',
		component: LoginTokenValidateView
	},
	{
		path: '/confirm',
		component: ConfirmView
	},
	{
		path: '/confirmpassword/:email',
		component: OTPConfrimView
	},
	{
		path: '/user/resetpassword',
		component: PasswordResetRequest
	},
	{
		path: '/reset',
		component: PasswordResetView
	},
	{
		path: '/otp',
		component: OTPView
	},
	{
		path: '/',
		component: DashView,
		children: [
			{
				path: 'dashboard',
				alias: '',
				component: DashboardView,
				name: 'Dashboard',
				meta: { description: 'Home', requiresAuth: true }
			},
			{
				path: '/eslips/generate',
				component: BuyerInvoices,
				name: 'Buyer Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/view',
				component: ViewInvoices,
				name: 'View Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/confirmed',
				component: ViewConfirmedInvoices,
				name: 'Confirmed Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/generated',
				component: ViewUnconfirmedInvoices,
				name: 'Generated Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/auction/result',
				component: AuctionResults,
				name: 'Auction Result',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/auction/:id/deleted',
				component: DeletedAuctionResultsInFile,
				name: 'Auction Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/auction/:id/checkoffSettlementDetails',
				component: AuctionResultsInFile,
				name: 'Auction Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/eslips/buyer',
				component: BuyerEslips,
				name: 'Buyer Eslips',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge',
				component: Charge,
				name: 'Charges',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/broker',
				component: BrockerCharge,
				name: 'BrockerCharges',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/warehouse',
				component: WarehouseCharge,
				name: 'WarehouseCharges',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/warehouse_create',
				component: WarehouseNewCharge,
				name: 'WarehouseNewCharges',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/warehouse_approve',
				component: WarehouseChargeApprove,
				name: 'WarehouseChargeApprove',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/warehouse_view',
				component: WarehouseChargeView,
				name: 'WarehouseChargeView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/milling_create',
				component: MillingCharge,
				name: 'MillingChargesCreate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/milling_view',
				component: MillingChargeView,
				name: 'MillingChargesView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/milling_approve',
				component: MillingChargeApprove,
				name: 'MillingChargesApprove',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/society_create',
				component: SocietyCharge,
				name: 'SocietyChargesCreate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf/delivery/cherry/files',
				component: UploadCherry,
				name: 'Upload Cherry',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf/delivery/cherry/creation',
				component: CreateCherry,
				name: 'Upload Cherry',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf/delivery/farmer/creation',
				component: CreateFarmer,
				name: 'Create Farmer',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/society_view',
				component: SocietyChargeView,
				name: 'SocietyChargesView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/society_approve',
				component: SocietyChargeApprove,
				name: 'SocietyChargesApprove',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/broker_create',
				component: BrokerCharge,
				name: 'BrokerChargeCreate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/broker_approve',
				component: BrokerChargeApprove,
				name: 'BrokerChargeApprove',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/charge/broker_view',
				component: BrokerChargeView,
				name: 'BrokerChargesView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/catalogue',
				component: CatalogueUpload,
				name: 'Upload Catalogue',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/file/auctionupload',
				component: AuctionUpload,
				name: 'Upload Auction',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/catalogue/:id/checkoffSettlementDetails',
				component: CatalogueDetails,
				name: 'Catalogue Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/catalogue/:id/deleted',
				component: CatalogueDeletedDetails,
				name: 'Catalogue Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/parchment',
				component: ParchmentUpload,
				name: 'Parchment',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/parchment/:id/checkoffSettlementDetails',
				component: ParchmentDetails,
				name: 'Parchment Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/parchment/:id/deleted',
				component: ParchmentDeletedDetails,
				name: 'Parchment Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/cleancoffee',
				component: CleanCoffeeUpload,
				name: 'Clean Coffee',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecured',
				component: EstateCuredUpload,
				name: 'Clean Coffee',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredMiller',
				component: EstateCuredMillerUpload,
				name: 'Estate Cured Miller',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredBroker',
				component: EstateCuredBrokerUpload,
				name: 'Estate Cured Broker',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecured/:id/checkoffSettlementDetails',
				component: EstateCuredDetails,
				name: 'Estate Cured Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecured/:id/file',
				component: EstateCuredDetailsFile,
				name: 'Estate Cured Coffee Details File',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredparchment/:id/checkoffSettlementDetails',
				component: EstateCuredParchmentDetails,
				name: 'Estate Cured Coffee Parchment Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredclean/:id/checkoffSettlementDetails',
				component: EstateCuredCleanDetails,
				name: 'Estate Cured Coffee Parchment Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweepings/upload',
				component: SweepingsUpload,
				name: 'Clean Coffee',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweepings/charges',
				component: SweepingsCharges,
				name: 'Clean Coffee',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweepings/catalogue',
				component: SweepingsCatalogue,
				name: 'Sweepings',
				meta: { description: '', requiresAuth: true }
			},
			// {
			// 	path: '/sweepings/:id/checkoffSettlementDetails',
			// 	component: SweepingsDetails,
			// 	name: 'Sweepings Coffee Details',
			// 	meta: { description: '', requiresAuth: true }
			// },
			{
				path: '/sweepings/holdingwarrants',
				component: SweepingsHoldingWarrants,
				name: 'Sweepings Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweepings/confirmwarrants',
				component: SweepingsConfirmWarrants,
				name: 'Sweepings Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/cleancoffee/:id/checkoffSettlementDetails',
				component: CleancoffeeDetails,
				name: 'Clean Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/cleancoffee/:id/deleted',
				component: CleancoffeeDeletedDetails,
				name: 'Clean Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/confirm',
				component: ConfirmWarrant,
				name: 'Confirm Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/view',
				component: ViewWarrant,
				name: 'View Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/utilization',
				component: WarrantUtilization,
				name: 'Warrant Utilization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/holding/view',
				component: ViewHoldingWarrant,
				name: 'View Holding Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/holding/views',
				component: ViewHoldingWarrants,
				name: 'View Holding Warrants',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/initiate/warrant/collection',
				component: InitiateWarrantCollection,
				name: 'Initiate Warrant Collection',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/approve/warrant/collection',
				component: ApproveWarrantCollection,
				name: ' Approve  Warrant Collection',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/pending/warrant/collection',
				component: WarrantPendingCollection,
				name: 'View Pending Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/mark/warrant/collected',
				component: MarkWarrantCollected,
				name: 'View Holding Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/internal/create',
				component: CreateInternalUserView,
				name: 'Create Internal User',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/internal/approve',
				component: ApproveInternalUserView,
				name: 'Approve Internal User',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/internal/view',
				component: ViewInternalUserView,
				name: 'Internal Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/admin/createrole',
				component: CreateRoleView,
				name: 'Create Roles',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/admin/viewroles',
				component: ViewRoleView,
				name: 'View Roles',
				meta: { description: 'View Roles', requiresAuth: true }
			},
			{
				path: '/permission/create',
				component: CreatePermissionView,
				name: 'Create Permissions',
				meta: { description: 'Create  Permission', requiresAuth: true }
			},
			{
				path: '/permission/view',
				component: ViewPermissionView,
				name: 'View Permissions',
				meta: { description: 'List of Permissions', requiresAuth: true }
			},
			{
				path: '/organization/create',
				component: CreateOrganizationView,
				name: 'Create Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/view',
				component: ViewOrganizationView,
				name: 'View Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/approve',
				component: ApproveOrganizationView,
				name: 'Approve Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/:id/users',
				component: OrganizationUsers,
				name: 'Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/external/approve',
				component: ApproveOrganizationUsers,
				name: 'External Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/updatepassword',
				component: UpdatePasswordView,
				name: 'Update Password',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/payment/received',
				component: ViewReceivedPayments,
				name: 'Received Payments',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/settlement/unapproved',
				component: ViewSettlements,
				name: 'Settlements',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/transaction',
				component: ViewTransactions,
				name: 'Transactions',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/paymentExceptions',
				component: ViewPaymentExceptions,
				name: 'PaymentExceptions',
				meta: { description: '' }
			},
			{
				path: '/farmers/farmers',
				component: UploadFarmers,
				name: 'UploadFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/farmercompany',
				component: UploadFarmerCompany,
				name: 'UploadFarmerCompany',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/view',
				component: ViewFarmers,
				name: 'ViewFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/paymentSchedule/',
				component: PaymentGenerationSchedule,
				name: 'ViewFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/schedule/view',
				component: ApprovePaymentSchedule,
				name: 'ApprovePaymentSchedule',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/communalRates/view',
				component: CommunalRatesView,
				name: 'CommunalRatesView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/payments/statement',
				component: FarmerStatementView,
				name: 'FarmerStatementView',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/schedule/checkoffSettlementDetails/:action/:commId',
				component: ViewFarmerSchedule,
				name: 'Farmers Loan History',
				meta: { description: '', requiresAuth: true }
			},

			{
				path: '/farmers/paymentSchedule/retries',
				component: RetryFarmerPayments,
				name: 'ViewFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/paymentSchedule/retries/approve',
				component: ApproveFarmerPaymentRetries,
				name: 'ViewFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/loanrequests',
				component: ViewLoanRequests,
				name: 'LoanRequests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/approvedrequests',
				component: ViewApprovedLoanRequests,
				name: 'ApprovedLoanRequests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/:id/checkoffSettlementDetails',
				component: FarmersDetails,
				name: 'Farmers Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmercompany/:id/checkoffSettlementDetails',
				component: FarmerCompanyDetails,
				name: 'Farmer Company Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/limits/:id/checkoffSettlementDetails',
				component: LimitDetails,
				name: 'Farmers Limit Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/limits/files',
				component: UploadLimits,
				name: 'Upload Farmers Limit',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/limits',
				component: ViewLimits,
				name: 'View Farmers Limit',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/summary',
				component: FarmersSummary,
				name: 'Farmers Summary',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/summary/:orgisationCode',
				component: FarmersSummaryDetails,
				name: 'Farmers Summary Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/loan/history/:organizationId/:farmerId',
				component: FarmerLoanHistory,
				name: 'Farmers Loan History',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/summary',
				component: LoanSummary,
				name: 'Loan Summary',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/summary/:orgisationCode',
				component: LoanSummaryDetails,
				name: 'Loan Summary Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/qrcode/:warrant',
				component: QrCode,
				name: 'QR Code Confirmation',
				meta: { description: '' }
			},
			{
				path: '/farmers/update/approve',
				component: FarmerUpdateApprove,
				name: 'Farmer Approve',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/recon',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/loan/reconfile.vue'),
				name: 'Loan Recon',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/managerate',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/ManageRates.vue'),
				name: 'Manage Rate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/managerate/approve',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/farmers/ApproveCherryRates.vue'),
				name: 'Approve Rate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grnfile',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/file/grnupload.vue'),
				name: 'GRN Upload',
				meta: { description: '', requiresAuth: true }
			},
      {
        path: '/directsalegrnfile',
        component: () => import(/* webpackChunkName: "farmers" */ '../components/views/file/directsalegrnupload.vue'),
        name: 'Direct Sale GRN Upload',
        meta: { description: '', requiresAuth: true }
      },
			{
				path: '/grnfile/:id/checkoffSettlementDetails',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/file/grnfiledetails.vue'),
				name: 'GRN Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grnfile/:id/deleted',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/file/deletedgrnfiledetails.vue'),
				name: 'GRN Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/approve_grn_records',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/dispatch/pendingapproval.vue'),
				name: 'Approve GRN Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/commission',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/loan/viewcommission.vue'),
				name: 'Commissions',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/unbulking/getallbyeslipid/:eslipid',
				component: GrowerSettlementView,
				name: 'unbulking',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/unbulking/getallbyunbulkedid/:unbulkedid',
				component: GrowerChargeSettlementView,
				name: 'unbulking',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/brokerTransaction/getAll',
				component: BrokerSettlementView,
				name: 'brokercharge',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/eslip/getByStatus',
				component: PaidEslipsView,
				name: 'paideslips',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/eslip/getByApprovalStatus',
				component: PendingApprovalEslipsView,
				name: 'pendingapprovaleslips',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/broker/pendingTransactions',
				component: BrokerTransactionsView,
				name: 'pendingbrokertransactions',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/growers-charge/pendingTransactions',
				component: SettleGrowersChargesView,
				name: 'pendingGrowerTransactions',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/nceTransaction/getAll',
				component: NceSettlementView,
				name: 'ncecharge'
			},
			{
				path: '/reports/paid_pending',
				component: PaidAndPendingPaymentsRpts,
				name: 'Paid and Pending Payments',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/grower_settlement_details',
				component: GrowersSettlementDetailsRpts,
				name: 'Growers Settlement Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/growers_settlement',
				component: GrowersSettlementRpts,
				name: 'Growers Settlement',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/unbulking_tracing_report',
				component: UnbulkingTracingRpt,
				name: 'Unbulking Tracing Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/buyer_report',
				component: BuyersRpt,
				name: 'Buyer Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/warehouse_report',
				component: WarehouseRpt,
				name: 'Warehouse Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sla/saledates',
				component: SaleDates,
				name: 'Sale Dates View',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sla/default',
				component: DefaultSLA,
				name: 'Sale Dates View',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/taxtype',
				component: TaxType,
				name: 'Tax Type View',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sla/custom',
				component: CustomOrgSLA,
				name: 'Custom Org View',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sla/seasons',
				component: SLASeasons,
				name: 'SLA Seasons View',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/miller_report',
				component: MillersRpt,
				name: 'Miller Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/broker_report',
				component: BrokersRpt,
				name: 'Broker Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/exceptional_report',
				component: ExceptionalRpt,
				name: 'Exceptional Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/cleancoffee/:id/checkoffSettlementDetails',
				component: CleancoffeeDetails,
				name: 'Clean Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/cleancoffee/:id/deleted',
				component: CleancoffeeDeletedDetails,
				name: 'Clean Coffee Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/confirm',
				component: ConfirmWarrant,
				name: 'Confirm Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/view',
				component: ViewWarrant,
				name: 'View Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/holding/view',
				component: ViewHoldingWarrant,
				name: 'View Holding Warrant',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/warrant/holding/views',
				component: ViewHoldingWarrants,
				name: 'View Holding Warrants',
				meta: { description: '', requiresAuth: true }
			},

			{
				path: '/user/internal/create',
				component: CreateInternalUserView,
				name: 'Create Internal User',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/internal/approve',
				component: ApproveInternalUserView,
				name: 'Approve Internal User',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/internal/view',
				component: ViewInternalUserView,
				name: 'Internal Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/admin/createrole',
				component: CreateRoleView,
				name: 'Create Roles',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/admin/viewroles',
				component: ViewRoleView,
				name: 'View Roles',
				meta: { description: 'View Roles', requiresAuth: true }
			},
			{
				path: '/permission/create',
				component: CreatePermissionView,
				name: 'Create Permissions',
				meta: { description: 'Create  Permission', requiresAuth: true }
			},
			{
				path: '/permission/view',
				component: ViewPermissionView,
				name: 'View Permissions',
				meta: { description: 'List of Permissions', requiresAuth: true }
			},
			{
				path: '/organization/create',
				component: CreateOrganizationView,
				name: 'Create Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/view',
				component: ViewOrganizationView,
				name: 'View Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/approve',
				component: ApproveOrganizationView,
				name: 'Approve Organization',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organization/:id/users',
				component: OrganizationUsers,
				name: 'Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/external/approve',
				component: ApproveOrganizationUsers,
				name: 'External Users',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/user/updatepassword',
				component: UpdatePasswordView,
				name: 'Update Password',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/payment/received',
				component: ViewReceivedPayments,
				name: 'Received Payments',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/settlement/unapproved',
				component: ViewSettlements,
				name: 'Settlements',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/transaction',
				component: ViewTransactions,
				name: 'Transactions',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/paymentExceptions',
				component: ViewPaymentExceptions,
				name: 'PaymentExceptions',
				meta: { description: '' }
			},
			{
				path: '/farmers/farmers',
				component: UploadFarmers,
				name: 'UploadFarmers',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf/delivery/parchment/files',
				component: UploadParchment,
				name: 'Upload Farmers Limit',
				meta: { description: '', requiresAuth: true }
			},

			{
				path: '/reports/warehouse_report',
				component: WarehouseRpt,
				name: 'Warehouse Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/miller_report',
				component: MillersRpt,
				name: 'Miller Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/broker_report',
				component: BrokersRpt,
				name: 'Broker Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/exceptional_report',
				component: ExceptionalRpt,
				name: 'Exceptional Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/grower_settlement',
				component: GrowerSettlementRpt,
				name: 'Grower Settlement Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/account_report',
				component: AccountRpt,
				name: 'Account Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/payment_report',
				component: PaymentRpt,
				name: 'Payment Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/penalty-report',
				component: PenaltyReport,
				name: 'Penalty Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/nce-levy-report',
				component: nceLevyReport,
				name: 'NCE Levy Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/reports/grower-sales-report',
				component: growerSalesReport,
				name: 'Grower Sales Report',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf_rate/create_ccarf_rate',
				component: CreateCCARFRate,
				name: 'Create CCARF Rate',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf_rate/view_ccarf_rates',
				component: ViewCCARFRates,
				name: 'View CCARF Rates',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/loan/requests',
				component: LoanRequests,
				name: 'View Loan Requests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grower/stock',
				component: GrowerStock,
				name: 'View Grower Stock Details Tracker',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grower/stock2',
				component: GrowerStock2,
				name: 'View Grower Stock Details Tracker',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grower/stock/:id',
				component: GrowerStockStatusDet,
				name: 'View Grower Stock Status Details',
				meta: {
					description: '',
					requiresAuth: true
				}
			},
			{
				path: '/grower/stock2/:id',
				component: GrowerStockStatusDet2,
				name: 'Catalogue Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/grower/non-checkoff',
				component: NonCheckOff,
				name: 'Grower Non CheckOff Account Statement',
				meta: { description: '', requiresAuth: true }
			},
      {
        path: '/grower/non-checkoff2',
        component: NonCheckOff2,
        name: 'Grower Non CheckOff Account Statement',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/grower/salestatement',
        component: GrowerSaleStatement,
        name: 'Grower Non CheckOff Account Statement',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/farmers/cherry/summaryReport',
        component: ViewCherryReport,
        name: 'ViewCherryReport',
        meta: { description: '', requiresAuth: true }
    },
	{
		path: '/cataloguefile/:id/details',
		component: () => import(/* webpackChunkName: "cataloguefiledetails" */ '../components/views/file/catalogue/cataloguefiledetails.vue'),
		name: 'Catalogue Details',
		meta: { description: '', requiresAuth: true }
	},
      {
        path: '/eudr/geomapagent',
        component: EUDRGeomapAgent,
        name: 'Geomap Agent',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/eudr/report',
        component: EUDRFarmersReport,
        name: 'Geomap Farmer Report',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/eudr/duediligencestatement',
        component: EUDRDueDeligenceStatement,
        name: 'EUDR Due Deligence Statement',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/eudr/generate',
        component: EUDRGeneratedDDS,
        name: 'Generated EUDR DDS',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/eudr/confirm',
        component: EUDRConfirmDDS,
        name: 'Generated EUDR DDS',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/ccarf/conversionRate',
        component: CcarfUsdKesRate,
        name: 'CcarfUsdKesRate',
        meta: { description: '', requiresAuth: true }
      },
      {
        path: '/ccarf/setCommunalRate',
        component: SetCommunalRateLimit,
        name: 'SetCommunalRateLimit',
        meta: { description: '', requiresAuth: true }
      },
	  {
				path: '/estatecuredmiller/:id/checkoffSettlementDetails',
				component: EstatecuredMillerDetails,
				name: 'Parchment Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredbroker',
				component: EstateCuredBrokerUpload,
				name: 'Broker EstateCured',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/estatecuredbrokerfile/:id/checkoffSettlementDetails',
				component: () => import(/* webpackChunkName: "farmers" */ '../components/views/file/estatecuredbrokerfiledetails.vue'),
				name: 'Catalogue Details',
				meta: { description: '', requiresAuth: true }
			},
	   {
				path: '/organisation/approve/requests',
				component: ApproveAllOrganizationView,
				name: 'ApproveAllOrganization Requests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/organisation/view/requests',
				component: MakersView,
				name: 'ViewAllOrganization Requests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweeping/:id/checkoffSettlementDetails',
				component: SweepingsDetails,
				name: 'Sweeping Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/sweeping/warrants',
				component: SweepingsConfirmedWarrants,
				name: 'Sweeping Confirmed Details',
				meta: { description: '', requiresAuth: true }
			},
			{

				path: '/specialitycatalogue/:id/checkoffSettlementDetails',
				component: SpecialityCatalogueDetails,
				name: 'Speciality Catalogue Details',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/specialitycatalogue',
				component: SpecialityCatalogueUpload,
				name: 'Upload Speciality Catalogue',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/ccarf/farmer/loan/schedule',
				component: UploadFcsLoanScedule,
				name: 'Upload Farmer Schedule',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/farmers/loan/schedule/:id/checkoffSettlementDetails',
				component: LoanScheduleDetails,
				name: 'Farmers Loan Schedule Details',
				meta: { description: '', requiresAuth: true }
			},
				{
				path: '/broker/payout/schedule',
				component: BrokerPayoutSchedule,
				name: 'Broker Payout Schedule',
				meta: { description: '', requiresAuth: true }
			},
				{
				path: '/broker/payout/schedule/view/:scheduleId',
				component: ViewBrokerSchedule,
				name: 'Broker Payout Schedule',
				meta: { description: '', requiresAuth: true }
			},
				{
				path: '/broker/payout/requests',
				component: ViewBrokerPayoutRequests,
				name: 'Broker Payout Requests',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/broker/schedule/:id/details',
				component: BrokerScheduleDetails,
				name: 'Broker Schedule Details',
				meta: { description: '', requiresAuth: true }
			},
				{
				path: '/invoice/miller/view',
				component: millerInvoices,
				name: 'Miller Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/warehouse/view',
				component: warehouseInvoices,
				name: 'Warehouse Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/grower/view',
				component: growerInvoices,
				name: 'Grower Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/nce/view',
				component: nceInvoices,
				name: 'Nce Invoices',
				meta: { description: '', requiresAuth: true }
			},
			{
				path: '/invoice/broker/view',
				component: brokerInvoices,
				name: 'Broker Invoices',
				meta: { description: '', requiresAuth: true }
			},

		]
	}, {
		// not found handler
		path: '*',
		component: NotFoundView
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
	if (
		to.matched.some((record) => record.meta.requiresAuth) &&
    (!router.app.$store.state.token || router.app.$store.state.token === 'null')
	) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		window.console.log('Not authenticated')
		next({
			path: '/login',
			query: { redirect: to.fullPath }
		})
	} else {
		if (store.state.token !== null) {
			const token = store.state.token.slice(7)
		//	checkToken(token)
		}
		next()
	}
})

if (window.localStorage) {
	var localUserString = window.localStorage.getItem('user') || 'null'
	var localUser = JSON.parse(localUserString)

	if (localUser && store && store.state && store.state.user !== localUser) {
		store.commit('SET_USER', localUser)
		store.commit('SET_TOKEN', window.localStorage.getItem('token'))
	}
}

export default router
